module.exports = __webpack_public_path__ + "img/1.31376e62.jpg";